import { getCookie, getApiHref, successInterceptor, failInterceptor } from '@kso/axios/lib/util';

/**
 * AXIOS 的相应拦截器
 * 拦截接口的请求 和 响应，上报埋点数据
 */
var reportAll = localStorage.getItem('kdocs_report_all');
// 正式环境（master）不上报这个字段  正式环境：'prod'  灰度：'prod_rc'  重保：prod-s; beta：'beta'  若有变动找 晓成哥
var envFromCookie = getCookie('env') || null;
var automatedTesting = getCookie('automated_testing') || null;
var interceptor = function interceptor() {
  var successList = [];
  var errorList = [];
  var successRate = 0;
  var errorRate = 0;
  try {
    // 成功按照 0.1% 的比例上报
    successRate = process.env.API_SUCCESS_RATE;
    // 失败按照 1% 的比例上报
    errorRate = process.env.API_ERROR_RATE;
  } catch (e) {}
  return {
    name: 'dwpoint',
    request: function request(config) {
      config._href = getApiHref();
      return config;
    },
    response: {
      success: function success(response) {
        var env;
        // 防止初始化时env值为空导致后续一直为空
        if (!envFromCookie || envFromCookie === 'noENV') {
          envFromCookie = getCookie('env') || 'noENV';
        }
        env = envFromCookie;
        if (!automatedTesting) {
          automatedTesting = getCookie('automated_testing') || 'no_automated_testing';
        }
        var isProd = env === 'prod';
        successInterceptor(response, null, successList, env, isProd, successRate, reportAll, automatedTesting);
        return response;
      },
      fail: function fail(error) {
        var env;
        if (!envFromCookie || envFromCookie === 'noENV') {
          envFromCookie = getCookie('env') || 'noENV';
        }
        env = envFromCookie;
        if (!automatedTesting) {
          automatedTesting = getCookie('automated_testing') || 'no_automated_testing';
        }
        var isProd = env === 'prod';
        failInterceptor(error, null, errorList, env, isProd, errorRate, reportAll, automatedTesting);
        return Promise.reject(error);
      }
    }
  };
};
function dwpoint () {
  this.$inject(interceptor());
}

export { dwpoint as default, interceptor };
